import React from 'react'
import RootLayout from './RootLayout'

const ssrRoutes = [
    {
        path: '/*',
        element: (<RootLayout />),
        children: [
            {
                index: true,
                element: <div />,
            },
        ],
    },
]

export default ssrRoutes

